export const MINUTE_HEIGHT_PX = 2;
export const MILLISECONDS_PER_HOUR = 1000 * 60 * 60;

export const MAX_HOUR_NOTE_CHARS = 2048;

export const AUTO_NOTE_STRATEGIES = [
  'off',
  'memory-titles',
  'with_reference',
  'without_reference',
] as const;

export const TRAINING_MINUTE_HEIGHT_PX = 1.5;
export const TRAINING_HOUR_HEIGHT_PX = 60 * TRAINING_MINUTE_HEIGHT_PX;

// Maybe do this? See previous PR on changing timeformats first.
// export const DURATION_FORMAT = 'h[h] mm[m]'; //is hardcoded to h:mm atm

export const HOUR_LAYOUT = {
  stepHeight: 10,
  stepMinutes: 15,
  baseHeight: 20,
  minHeight: 50,
  minHeightWithClient: 70,
  minHeightWithTimer: 65,
  minContentHeight: 10,
  maxHeight: 1000,
  cssLineHeight: 1,
  cssFontSize: 12,
  footerHeight: 32,
  minMinutesRequiredForProjectNameToShow: 0,
  maxContentLines: 2,
};

export const SUGGESTED_TIME_TOOLTIP = 'Suggested time based on memories. Only visible to you';

export const HOUR_EDITOR_MAX_SUGGESTIONS = 4;

export const HOUR_EDITOR_MAX_PINNED_PROJECTS = 20;

// Todo: Do this for everything related to .durationDraftMode
// export const DURATION_DRAFT_MODE = {
//   manual: 'manual',
// }
